import React, { useEffect } from 'react';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { DownloadsShopDotsTable } from 'widgets/downloads';

export const DownloadsShopDotsPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Акции - Торговые точки'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <DownloadsShopDotsTable />;
};
